module.exports = __webpack_public_path__ + "static/media/lesson_not_available_ic.7dd7ae03.svg";